import React from "react";
import { useSelector } from "react-redux";
import { type RootState } from "../../../../store";
import styles from "../../../constructionsNew/constructionsNew.module.scss";
import IsaacEntityNavigation from "../../../../components/isaacEntityNavigation/IsaacEntityNavigation";
import PathConstants from "../../../../routes/pathConstants";

const CalculationNavigationNew: React.FunctionComponent = () => {
    const {nextId: nextConstructionId, prevId: prevConstructionId} = useSelector((state: RootState) => state.constructionNew);
    const {nextId: nextCalculationId, prevId: prevCalculationId} = useSelector((state: RootState) => state.constructionCalculationsNew);

    return (
    <div className={styles.navigation}>
      <IsaacEntityNavigation
        nextPath={
          nextConstructionId !== null
            ? `/${PathConstants.Constructions}/${nextConstructionId}/${PathConstants.Calculations}/${nextCalculationId}`
            : null
        }
        prevPath={
          prevConstructionId !== null
            ? `/${PathConstants.Constructions}/${prevConstructionId}/${PathConstants.Calculations}/${prevCalculationId}`
            : null
        }
        nextTooTip="Got to next construction calculation."
        prevTooTip="Got to previous construction calculation."
      />
    </div>
  );
}

export default CalculationNavigationNew;